/**
 * Region Fragment
 *
 * Common pattern for region references used in nursery-search-block.
 */

/**
 * Field projection for a region reference
 * Can be interpolated into block queries
 */
export const regionFields = `
  _id,
  _type,
  name
`
